export enum ReviewAllocationSplitType
{
Default = 0,
Percentage = 1,
Absolute = 2
}